module.exports = __webpack_public_path__ + "media/fonts/OpenSans-Italic-a9d385277b4833d366ce92db7d697a3c.ttf";